// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"bb39ff693e2b617c32f6","873":"70403277bd5262d9a0d6"}[chunkId] + ".js";
};